// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lessions-data-erogato {
  float: right;
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 0.5rem;
}

.lessions-data-assenze-perc-out-fr {
  float: right;
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 0.7rem;
}

.lessions-data-assenze-perc-out-fl {
  float: left;
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 0.7rem;
}

.lessions-tot-assenze-out {
  float: left;
  margin-left: 2px;
  margin-top: 0.5rem;
}

@media (min-width: 768px) {
  .progress-limit {
    max-width: 90%;
  }
}
@media (max-width: 768px) {
  .progress-limit {
    max-width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/progress-bar-studente/progress-bar-studente.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAR;;AAQM;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AALR;;AAOM;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAJR;;AAOM;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAJR;;AAQM;EACE;IACE,cAAA;EALR;AACF;AAQM;EACE;IACE,cAAA;EANR;AACF","sourcesContent":["\n    .lessions-data-erogato {\n        float: right;\n        margin-left: 2px;\n        margin-right: 2px;\n        margin-top: 0.5rem;\n      }\n  \n      // .lessions-data-assenze-perc-out {\n      //   float: left;\n      //   margin-top: 0.6rem;\n      // } \n      \n      .lessions-data-assenze-perc-out-fr {\n        float: right;\n        margin-left: 2px;\n        margin-right: 2px;\n        margin-top: 0.7rem;\n      }\n      .lessions-data-assenze-perc-out-fl {\n        float: left;\n        margin-left: 2px;\n        margin-right: 2px;\n        margin-top: 0.7rem;\n      }\n\n      .lessions-tot-assenze-out {\n        float: left;\n        margin-left: 2px;\n        margin-top: 0.5rem;\n      }\n  \n      \n      @media (min-width: 768px) {\n        .progress-limit {\n          max-width: 90%;\n        }\n      }\n    \n      @media (max-width: 768px) {\n        .progress-limit {\n          max-width: 70%;\n        }\n      }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
